/**
 * Encodes spaces in image URLs to prevent broken srcSet links
 * @param url - The image URL that may contain spaces
 * @returns The URL with spaces properly encoded as %20
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const encodeImageUrl = (url?: any): string => {
  if (!url) return '';
  return String(url).replace(/ /g, '%20');
};
